import React from 'react'
import { Grid, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const GridSpinner = ({ width, color, ...rest }) => {
  return (
    <Grid
      {...rest}
      key={'grid-spinner-key'}
      flexDirection={'row'}
      flexJustify={'center'}
      flexAlign={'center'}
    >
      <Grid justifyContent={'center'}>
        <Spinner
          width={width}
          color={color}
        />
      </Grid>
    </Grid>
  )
}

GridSpinner.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
}

export default GridSpinner
